import {translate} from '@docusaurus/Translate';
import type {ReactNode} from 'react';
import {useEffect} from 'react';
import {useLocation} from '@docusaurus/router';
import useBaseUrl from '@docusaurus/useBaseUrl';

import {useAssistant} from './AssistantContext';
import type {PageContext} from './assistantConversation';

function normalizeTitle(value: string): string {
  return value.replace(/\s+/g, ' ').replace(/\s*[|·-]\s*FolderSpan\s*$/i, '').trim().slice(0, 256);
}

export function readPageContext(path: string): PageContext {
  const heading = document.querySelector<HTMLElement>('main h1');
  return {
    title: normalizeTitle(heading?.textContent || document.title || translate({message: 'FolderSpan 文档'})) || translate({message: 'FolderSpan 文档'}),
    path: path.slice(0, 512) || '/',
  };
}

export default function PageContextTracker(): ReactNode {
  const location = useLocation();
  const assistantPath = useBaseUrl('/ai-docs').replace(/\/+$/, '');
  const {setSourceContext} = useAssistant();

  useEffect(() => {
    const normalizedPath = location.pathname.replace(/\/+$/, '') || '/';
    if (normalizedPath === assistantPath) {
      return;
    }

    let frameId = 0;
    let titleObserver: MutationObserver | null = null;

    const captureContext = () => {
      setSourceContext(readPageContext(`${location.pathname}${location.search}${location.hash}`));
    };

    frameId = window.requestAnimationFrame(captureContext);
    const titleElement = document.querySelector('title');
    if (titleElement) {
      titleObserver = new MutationObserver(captureContext);
      titleObserver.observe(titleElement, {childList: true, subtree: true});
    }

    return () => {
      window.cancelAnimationFrame(frameId);
      titleObserver?.disconnect();
    };
  }, [assistantPath, location.hash, location.pathname, location.search, setSourceContext]);

  return null;
}
